<template>
  <div id="files" class="sun main">
    <div class="files" v-if="agreement">
      <!--image-->
      <img class="img"
           :src="agreement.image"
           v-if="agreement.image">
      <!--pdf-->
      <iframe v-else-if="agreement.file"
              :id="Date.now()"
              type="application/pdf"
              class="pdf" :src="`https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(agreement.file)}`"></iframe>
      <!--Button-->
    </div>
    <button class="confirm active" @click="$router.push({ name: 'agreements' })">
      확인
    </button>
  </div>
</template>

<script>
export default {
  name: 'AgreementsDetail',
  props: ['agreement'],
  async created() {
    this.$store.commit('ui/headerTitle', '약관 보기')
    if (!this.agreement) {
      this.$router.push({ name: 'agreements' })
    }
  },
}
</script>

<style lang="scss" scoped>
  #files {
    width: 100%;
    .files {
      width: 100%;
      height: calc(100vh - 60px);
      background-color: #F4FAFF;
      overflow: auto;
      .pdf, .img {
        width: 100%;
        height: calc(100% - 68px);
      }
    }
  }

.confirm {
  position: absolute;
  transform: translateX(-50%);
  left: 50%;
  bottom: 0;
  width: 100%;
  height: 68px;
  font-size: 22px;
  color: #727d8c;
  font-weight: bold;
  background-color: #e3ecf6;
  z-index: 1000;

  &.active {
    color: white;
    background-color: #1baaf1;
  }
}
</style>
